<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="applicationList"
	[loading]="!applicationList"
	[globalFilterFields]="app.keys(applicationList)"
	[rowHover]="true"
	[rows]="10"
	[showCurrentPageReport]="true"
	[rowsPerPageOptions]="[10, 25, 50]"
	responsiveLayout="scroll"
	[paginator]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} recordName"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="BusinessInformation.MerchantDba">
				<div class="d-flex w-100">
					DBA
					<p-sortIcon field="BusinessInformation.MerchantDba"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="BusinessInformation.MerchantDba" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="BusinessInformation.LegalBusinessName">
				<div class="d-flex w-100">
					Legal Business Name
					<p-sortIcon field="BusinessInformation.LegalBusinessName"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="BusinessInformation.LegalBusinessName" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="BusinessInformation.BusinessPhysicalAddress.City">
				<div class="d-flex w-100">
					City, State Zip
					<p-sortIcon field="BusinessInformation.BusinessPhysicalAddress.City"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="BusinessInformation.BusinessPhysicalAddress.City" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="BusinessInformation.PrimaryContactBusinessManager">
				<div class="d-flex w-100">
					Primary Contact
					<p-sortIcon field="BusinessInformation.PrimaryContactBusinessManager"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="BusinessInformation.PrimaryContactBusinessManager" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="status">
				<div class="d-flex w-100">
					Application Status
					<p-sortIcon field="status"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter
							field="Summary.CardBrand"
							matchMode="equals"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
							class="ml-auto"
						>
							<ng-template pTemplate="header">
								<div class="px-3 pt-3 pb-0">
									<span class="font-bold">Status</span>
								</div>
							</ng-template>
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-multiSelect
									[ngModel]="value"
									[options]="applicationStatusList"
									optionValue="label"
									optionLabel="label"
									placeholder="Any"
									(onChange)="filter($event.value)"
								>
									<ng-template let-option pTemplate="item">
										<div class="p-multiselect-representative-option">
											<span class="ml-1">{{ option.label }}</span>
										</div>
									</ng-template>
								</p-multiSelect>
							</ng-template>
						</p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="viewApplication(rec)">
			<td>
				{{ rec.BusinessInformation.MerchantDba }}
			</td>
			<td>
				{{ rec.BusinessInformation.LegalBusinessName }}
			</td>
			<td>
				{{ rec.BusinessInformation.BusinessPhysicalAddress.CityStatePostalCode }}
			</td>
			<td>{{ rec.BusinessInformation.PrimaryContactBusinessManager }}</td>
			<td>
				{{ rec.status }}
			</td>
		</tr>
	</ng-template>
</p-table>
